import { Button } from '@fox/atoms/src/button/index';
import { Select } from '@fox/atoms/src/select/index';
import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { FlexColumnSmallSpaced } from '@fox/layout/src/flex';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { QuestionStyleTypes } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context/form-runtime-context';
import { QuestionFieldMetadata } from '../contracts';
import { updateAnswerForContact } from '../util';
import { IAdditionalProfileFieldChoice } from './contracts';

export const CustomFieldSelect = (props: {
	field: IAdditionalProfileFieldChoice;
	currentAnswerSelections: any;
	currentAnswer: any;
	contactId: string;
	id: string;
	questionType: string;
	meta?: QuestionFieldMetadata;
}) => {
	const { answerQuestion } = useFormRuntimeContext();
	const { field, currentAnswer, currentAnswerSelections, contactId, id, meta, questionType } = props;

	let jsonAnswer = contactId ? currentAnswerSelections?.contacts?.find(c => c.id === contactId) : undefined;
	let answer = jsonAnswer ? jsonAnswer?.[field?.id] : undefined;

	const theme = useContext(ThemeContext);
	const allSelected = (answer?.length ?? 0) >= (field.options?.filter(o => !o.hide)?.length ?? 0);

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(
		QuestionStyleTypes.answer,
		{
			color: theme?.colors?.font,
			fontSize: 13
		},
		id
	);

	if (meta?.displayType === 'dropdown') {
		const options = field.options?.filter(o => !o.hide) ?? [];
		const value = field.isMulti ? answer?.map(a => options.find(o => o.id === a)) : options.find(o => o.id === answer);

		return (
			<Select<(typeof options)[number], boolean, true, false>
				style={{ marginTop: '5px' }}
				fullWidth
				disableClearable
				getOptionLabel={option => option?.labelOverride || option?.label || ''}
				size="small"
				multiple={field.isMulti}
				value={value}
				onChange={(_, val) => {
					if (contactId) {
						if (field.isMulti && Array.isArray(val)) {
							answer = val.map(v => v.id);
						} else if (!field.isMulti && !Array.isArray(val)) {
							answer = val.id;
						}

						updateAnswerForContact(currentAnswer, currentAnswerSelections, contactId, answerQuestion, field.id, answer, questionType);
					}
				}}
				options={options}
			/>
		);
	}

	return (
		<FlexColumnSmallSpaced>
			{props.field?.isMulti && meta?.selectAll ? (
				<Button
					size="small"
					onClick={() => {
						if (contactId) {
							answer = allSelected ? [] : field.options?.filter(o => !o.hide)?.map(o => o.id);
							updateAnswerForContact(currentAnswer, currentAnswerSelections, contactId, answerQuestion, field.id, answer, questionType);
						}
					}}
					title={allSelected ? 'Unselect all' : 'Select all'}
					children={allSelected ? 'Unselect all' : 'Select all'}
					variant="secondary"
					color="inherit"
					style={{ alignSelf: 'start' }}
				/>
			) : null}
			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 5,
					flexDirection: meta?.orientation === 'horizontal' ? 'row' : 'column',
					alignItems: 'center',
					justifyContent: meta?.orientation === 'horizontal' ? undefined : 'flex-start',
					marginTop: '5px'
				}}
			>
				{field.options
					?.filter(o => !o.hide)
					?.map(o => {
						return (
							<div
								onClick={() => {
									if (contactId) {
										const selected = answer?.includes(o.id) === true;
										if (selected) {
											if (answer?.filter) answer = answer?.filter(f => f !== o.id);
											else answer = undefined;
										} else {
											if (field?.isMulti) {
												answer = answer ?? [];
												answer.push(o.id);
											} else answer = [o.id];
										}
										updateAnswerForContact(
											currentAnswer,
											currentAnswerSelections,
											contactId,
											answerQuestion,
											field.id,
											answer,
											questionType
										);
									}
								}}
								key={o.id}
								style={{
									display: 'flex',
									width: meta?.orientation === 'horizontal' ? 'initial' : '100%',
									gap: 5,
									alignItems: 'center',
									cursor: 'pointer',
									fontSize,
									color,
									fontFamily,
									fontStyle,
									textDecoration,
									fontWeight
								}}
							>
								<input
									onSelect={e => e.preventDefault()}
									onChange={() => {}}
									style={{
										flex: 1,
										marginTop: 'auto',
										marginBottom: 'auto',
										maxWidth: 20
									}}
									checked={contactId ? answer?.indexOf && answer?.includes(o.id) === true : false}
									type={meta?.displayType !== undefined ? meta?.displayType : field.isMulti ? 'checkbox' : 'radio'}
								/>
								{!strIsNullOrEmpty(o?.labelOverride) ? o.labelOverride : o.label}
							</div>
						);
					})}
			</div>
		</FlexColumnSmallSpaced>
	);
};
